export const API_URL =
  // eslint-disable-next-line eqeqeq
  window.location.hostname == "localhost"
    ? "http://localhost:5001/onfleek-reunion/us-central1/app/"
    : "https://us-central1-onfleek-reunion.cloudfunctions.net/app/";
export const STRIPE_PK =
  "pk_live_51KwR5UEsA04C1YttIovOtf5oz6dJierxV6idf5fplSz8h9upMhpwZQGluuaCKkM6oEpiXKIISLJ3QwSbEakCXOYt00B1ZWLnAK";
//"pk_test_51KwR5UEsA04C1YttTmqBhenWaHUTy1jQXzgtoViVNM2hGoOSGCJimIQ7555dz1uBvgag46THltBMYGewse1lB3cU00TZyihYXF";
